@let data = state();
@if (data === null || data.isLoading) {
  <div
    class="rounded-lg bg-surface-magic dark:bg-surface-magic-darkmode border border-outline dark:border-outline-darkmode"
  >
    <h3
      class="px-6 py-5 font-semibold leading-6 border-b border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="block w-full rounded-full h-5" />
    </h3>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-5 px-6 py-5">
      <ui-skeleton class="w-full rounded-full h-5" />
      <ui-skeleton class="w-full rounded-full h-5" />
      <ui-skeleton class="w-full rounded-full h-5" />
      <ui-skeleton class="w-full rounded-full h-5" />
      <ui-skeleton class="w-full rounded-full h-5" />
      <ui-skeleton class="w-full rounded-full h-5" />
    </div>
  </div>
} @else {
  <div
    class="rounded-lg bg-surface-magic dark:bg-surface-magic-darkmode border border-outline dark:border-outline-darkmode"
  >
    @if (data.error) {
      <div class="px-6 py-5">
        <app-error-component />
      </div>
    } @else {
      <h3
        class="px-6 py-5 font-semibold leading-6 border-b border-outline dark:border-outline-darkmode"
      >
        {{ 'cockpit.analysis.consumption.detailsKpiCard.title' | transloco }}
      </h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 px-6 py-5">
        <span class="text-sm leading-6 font-semibold">
          @switch (filter().granularity) {
            @case ('YEAR') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.totalConsumption'
                  | transloco: { timePeriod: filter().date | date: 'yyyy' }
              }}
            }
            @case ('MONTH') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.totalConsumption'
                  | transloco: { timePeriod: filter().date | date: 'MMMM yyyy' }
              }}
            }
            @case ('WEEK') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.totalConsumption'
                  | transloco
                    : {
                        timePeriod:
                          (selectedFrom() | date: 'dd.MM.') +
                          ' - ' +
                          (selectedTo() | date: 'dd.MM.yyyy'),
                      }
              }}
            }
            @case ('DAY') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.totalConsumption'
                  | transloco: { timePeriod: filter().date | date: 'dd.MM.yyyy' }
              }}
            }
          }
        </span>
        <span
          class="text-sm leading-6 text-right text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ data.data?.usageSummary?.total ?? 0 | germanNumber: 0 }}
          {{ 'cockpit.analysis.consumption.unitKwh' | transloco }}
        </span>
        <span class="text-sm leading-6 font-semibold">
          @switch (filter().granularity) {
            @case ('YEAR')
            @case ('MONTH')
            @case ('WEEK') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.highestConsumption'
                  | transloco
                    : {
                        granularity:
                          'cockpit.analysis.consumption.detailsKpiCard.granularityDay' | transloco,
                      }
              }}
            }
            @case ('DAY') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.highestConsumption'
                  | transloco
                    : {
                        granularity:
                          'cockpit.analysis.consumption.detailsKpiCard.granularityHour' | transloco,
                      }
              }}
            }
          }
        </span>
        <span
          class="text-sm leading-6 text-right text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ data.data?.usageSummary?.highest ?? 0 | germanNumber: 0 }}
          {{ 'cockpit.analysis.consumption.unitKwh' | transloco }}
        </span>
        <span class="text-sm leading-6 font-semibold">
          @switch (filter().granularity) {
            @case ('YEAR')
            @case ('MONTH')
            @case ('WEEK') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.lowestConsumption'
                  | transloco
                    : {
                        granularity:
                          'cockpit.analysis.consumption.detailsKpiCard.granularityDay' | transloco,
                      }
              }}
            }
            @case ('DAY') {
              {{
                'cockpit.analysis.consumption.detailsKpiCard.lowestConsumption'
                  | transloco
                    : {
                        granularity:
                          'cockpit.analysis.consumption.detailsKpiCard.granularityHour' | transloco,
                      }
              }}
            }
          }
        </span>
        <span
          class="text-sm leading-6 text-right text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ data.data?.usageSummary?.lowest ?? 0 | germanNumber: 0 }}
          {{ 'cockpit.analysis.consumption.unitKwh' | transloco }}
        </span>
      </div>
    }
  </div>
}
